module.exports = __webpack_public_path__ + "img/game3.904030f5.png";